<div class="container-fluid title">
    <div class="columns is-multiline">
        <div class="column is-8">
            <h1 class="title">Gestor Clientes</h1>
        </div>
        <div class="column is-4" style="display: flex; justify-content: end; align-items: center; gap: 1rem; padding-right: 5rem;">
            <button class="button expirations-button" (click)="openExpirationsModal()">
                <fa-icon class="expirations-icon" [icon]="faCalendarClock"></fa-icon>
                Próximas caducidades
            </button>
            @if(hasEditPermission) {
                <button class="button create-client-button" (click)="openCreationModal()">
                    <fa-icon class="create-client-icon" [icon]="faUserPlus"></fa-icon>
                    Añadir cliente
                </button>
            }
        </div>
    </div>
</div>
<div class="container-fluid content-page background">
    <div class="tabs is-fullwidth is-primary">
        <ul>
            @for (tab of tabs; track tab.key) {
                <li [ngClass]="{'is-active': tab.key === activeTab}">
                    <a (click)="changeTab(tab)">{{tab.name}}
                        @if(tab.key === 'pending' && pendingCount > 0) {
                            <span class="tag is-danger">{{pendingCount}}</span>
                        }
                    </a>
                    
                </li>
            }
        </ul>
    </div>
    
    <div class="columns is-multiline filters-container">
        <div class="column is-2">
            <p-dropdown
            [options]="clientCodes"
            [(ngModel)]="selectedClientCodes" 
            optionLabel="code"
            optionValue="code"
            [filter]="true" 
            filterBy="code" 
            [showClear]="true"
            placeholder="Cod. Cliente"
            (onClear)="onClientCodeCleared()"
            (onChange)="onClientCodeSelected($event)"
            [emptyFilterMessage]="'No se encontraron resultados'"/>

        </div>
        <div class="column is-2">
            <p-dropdown
            [options]="clients" 
            [(ngModel)]="selectedClients" 
            optionLabel="name"
            optionValue="id"
            [filter]="true" 
            filterBy="name" 
            [showClear]="true"
            placeholder="Cliente"
            (onClear)="onClientCleared()"
            (onChange)="onClientSelected($event)"
            [emptyFilterMessage]="'No se encontraron resultados'"/>

        </div>

        <div class="column is-2">
            <p-multiSelect
                [options]="responsables"
                [filter]="false"
                [(ngModel)]="selectedResponsible"
                optionLabel="name"
                optionValue="id"
                placeholder="Responsable"
                (onChange)="onResponsibleSelected($event)"
                (onClear)="onResponsibleCleared()"
                [showClear]="true"
                [emptyFilterMessage]="'No se encontraron resultados'"
            />

        </div>

        <div class="column is-2">
            <p-dropdown
                [options]="personTypes"
                [filter]="false"
                [(ngModel)]="selectedPersonType"
                optionLabel="label"
                optionValue="value"
                placeholder="Tipo de cliente"
                (onChange)="onPersonTypeSelected($event)"
                (onClear)="onPersonTypeCleared()"
                [showClear]="true"
                [emptyFilterMessage]="'No se encontraron resultados'"
            />

        </div>
        
    </div> 
    @if (!isLoading) {
        <app-clients-table [configTable]="configTable"></app-clients-table>
    <div class="pagination-container">
        <app-pagination
            [currentPage]="currentPage" 
            [totalPages]= "maxPages"
            (pageChange)="onPageChange($event)">
        </app-pagination>
    </div>
    }@else {
        <div class="column is-12" style="display: flex; justify-content: center; margin-top: 100px;">
            <p-progressSpinner ariaLabel="loading"
            styleClass="custom-spinner"/>        </div>
    }
    
</div>

@if(isCreationModalVisible) {
    <div class="modal is-active">
        <div class="modal-background" (click)="closeCreationModal()"></div>
            <div class="modal-content">
                <div class="box">
                    <h1 class="title">Añadir cliente</h1>
                    <div class="columns is-multiline">
                        <div class="column is-12">   
                            <div class="field">
                                <label class="label">
                                    Tipo de cliente
                                </label>
                                <p-dropdown
                                [options]="personTypes" 
                                [(ngModel)]="selectedCreationPersonType" 
                                optionLabel="label"
                                optionValue="value" 
                                placeholder="Seleccionar"
                                ></p-dropdown>
                            </div>
                        </div>
                        <div class="column is-12">   
                            <div class="field">
                                <label class="label">
                                    Tipo de relación
                                </label>
                                <p-dropdown
                                [options]="relationTypes" 
                                [(ngModel)]="selectedCreationRelationType" 
                                optionLabel="label"
                                optionValue="value" 
                                placeholder="Seleccionar"
                                ></p-dropdown>
                            </div>
                        </div>
                        <div class="buttons-container">
                            <button class="button is-outlined cancel-button" (click)="closeCreationModal()">Cancelar</button>
                            <button class="comment-button button is-pulled-right" (click)="createClient()" [disabled]="!selectedCreationRelationType || !selectedCreationPersonType">Aceptar</button>      
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    
}

@if(isExpirationsModalVisible) {
    <div class="modal is-active expirations-modal">
        <div class="modal-background" (click)="closeExpirationsModal()"></div>
        <div class="modal-content">
            <div class="box">
                <div class="expirations-modal-header">
                    <h1 class="title">
                        <fa-icon [icon]="faCalendarClock"></fa-icon>
                        Próximas caducidades
                    </h1>
                    <button class="delete is-medium" aria-label="close" (click)="closeExpirationsModal()"></button>
                </div>
                @if(isLoadingExpirations) {
                    <div style="display: flex; justify-content: center; padding: 2rem;">
                        <p-progressSpinner ariaLabel="loading" styleClass="custom-spinner"/>
                    </div>
                } @else if(expirations.length === 0) {
                    <p class="has-text-grey">No hay caducidades en los próximos 3 meses.</p>
                } @else {
                    <table class="table is-fullwidth is-hoverable expirations-table">
                        <thead>
                            <tr>
                                <th>Código</th>
                                <th>Cliente</th>
                                <th>Tipo</th>
                                <th>Descripción</th>
                                <th>Fecha</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(exp of expirations; track $index) {
                                <tr
                                    class="expirations-table-row"
                                    (click)="navigateToExpirationClient(exp)"
                                    (keydown.enter)="navigateToExpirationClient(exp)"
                                    tabindex="0"
                                >
                                    <td class="expiration-code">{{ exp.clientCode ?? '—' }}</td>
                                    <td class="expiration-client-name">{{ exp.clientName }}</td>
                                    <td class="expiration-type">{{ exp.type }}</td>
                                    <td class="expiration-description">{{ exp.description }}</td>
                                    <td class="expiration-date">{{ exp.expirationDate | date:'dd/MM/yyyy' }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    </div>
}